export const fontColors = {
  primary: 'black',
  secondary: 'white',
}

export const colors = {
  background: '#121214',
  headline: '#fffffe',
  paragraph: '#9fa5f8',
  button: '#8257e5',
  buttonText: '#fffffe',
  secondary: '#fcfbff',
  main: '#fffffe',
  highlight: '#5350d1',
  tertiary: '#2cb67d',
}